function getEmbedUrl(url) {
  if (!url) return null;
  // YouTube
  const yt = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([\w-]{11})/);
  if (yt) return `https://www.youtube.com/embed/${yt[1]}`;
  // Vimeo
  const vm = url.match(/vimeo\.com\/(\d+)/);
  if (vm) return `https://player.vimeo.com/video/${vm[1]}`;
  return url;
}

export default function VideoBlock({ data }) {
  const embed = getEmbedUrl(data?.url);
  if (!embed) return null;
  return (
    <section className="py-10 md:py-14">
      <div className="max-w-4xl mx-auto px-6 md:px-8">
        <div className="aspect-video rounded-2xl overflow-hidden border" style={{ borderColor: "var(--wp-border)" }}>
          <iframe
            src={embed}
            title={data?.caption || "Video"}
            className="w-full h-full"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
        {data?.caption && (
          <p className="text-sm mt-3 text-center" style={{ color: "var(--wp-text-muted)" }}>
            {data.caption}
          </p>
        )}
      </div>
    </section>
  );
}
